import {createStrokeSVG} from './TEMPLATE'

// tabler: gif
export const GifSquare_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M8 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1',
    'M12 8v8',
    'M16 12h3',
    'M20 8h-4v8',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
